"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateYear = exports.groupBy = void 0;
const toConsumableArray_1 = __importDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
require("core-js/modules/es.array.reduce.js");
// group items array based on the
// value returned by calling fn with the current iterated item
function groupBy(items, fn) {
    return Object.entries(items.reduce(function (result, item) {
        var _Object$assign;
        return Object.assign({}, result, (_Object$assign = {}, _Object$assign[fn(item)] = [].concat(toConsumableArray_1.default(result[fn(item)] || []), [item]), _Object$assign));
    }, {})).reduce(function (acc, curr) {
        return [].concat(toConsumableArray_1.default(acc), [{
                year: curr[0],
                posts: curr[1]
            }]);
    }, []);
} // get the Year of a specified date
exports.groupBy = groupBy;
function getDateYear(_ref) {
    var _node$frontmatter;
    var node = _ref.node;
    return new Date(node === null || node === void 0 ? void 0 : (_node$frontmatter = node.frontmatter) === null || _node$frontmatter === void 0 ? void 0 : _node$frontmatter.date).getFullYear();
}
exports.getDateYear = getDateYear;
